import Component from "@glimmer/component";
import { hash } from "@ember/helper";
import CategoryChooser from "discourse/select-kit/components/category-chooser";

export default class CategoryIdInput extends Component {
  // CategoryChooser will try to modify the value of value,
  // triggering a setting-on-hash error. So we have to do the dirty work.
  get data() {
    return {
      value: this.args.field.value,
    };
  }

  <template>
    <@Control id={{@field.id}}>
      <CategoryChooser
        name={{@info.identifier}}
        @onChange={{@field.set}}
        @options={{hash
          allowUncategorized=null
          autoInsertNoneItem=true
          none=true
        }}
        @value={{this.data.value}}
      />
    </@Control>
  </template>
}
